var map = {
  "./da.json": "Sba",
  "./sv.json": "Vg",
  "./ja.json": "jUl",
  "./fr.json": "bX7",
  "./es.json": "FXD",
  "./nb.json": "j9",
  "./cs.json": "s8",
  "./en.json": "NL",
  "./cz.json": "gO",
  "./pl.json": "sY",
  "./ro.json": "TK0",
  "./nl.json": "iR4",
  "./de.json": "d5",
  "./it.json": "Ykl",
  "./dk.json": "zt"
};
function __rspack_async_context(req) {
  return Promise.resolve().then(() => {
if(!__webpack_require__.o(map, req)) {
  var e = new Error("Cannot find module '" + req + "'");
  e.code = 'MODULE_NOT_FOUND';
  throw e;
}

var id = map[req];
return __webpack_require__.t(id, 3 | 16);
});
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "OGc";
module.exports = __rspack_async_context;
